namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_map_widget_float_text_md, {
		
		background: {
			color: $mol_theme.card,
		},

		Md: {
			pointerEvents: 'none',
		},
		
	} )
	
}
